var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list draft-curriculum-list media-list"},[_c('ul',_vm._l((_vm.curriculums),function(curriculum){return _c('draft-curriculum-list-item',{key:curriculum.id,attrs:{"curriculum":curriculum},on:{"click":function($event){return _vm.$emit('click', curriculum.id)}}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }